import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Protect routes that require login
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them along to that page after they login,
    // which is a nicer user experience than dropping them off on the home page.
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />; // Render children or nested routes
};

// Protect routes that require admin privileges
export const AdminRoute = ({ children }) => {
    const { isLoggedIn, isAdmin } = useAuth();

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }
    if (!isAdmin) {
        // Maybe redirect to an "Unauthorized" page or back to dashboard
         console.warn("Access denied: Admin required.");
        return <Navigate to="/" replace />; // Redirect to home/dashboard
    }

    return children ? children : <Outlet />; // Render children or nested routes
}

export default ProtectedRoute;
